import { isLocal } from "src/utils/BasePathTools";
import { FetchOptions, GridIdForZaraParams } from "../api.models";
import { getEnv } from "src/utils/EnvironmentTools";

export async function gridIdForZara( { storeId, universeCode, gridCode, lang, }: GridIdForZaraParams ): Promise<string> {

    const options: FetchOptions = {
      method: "GET",
    };
  
    const basepath = isLocal ?  `${window.location.origin}`:`${getEnv().resellApiHost}`
  
    const url = new URL(`/api/v2/search/filters/gridmapping`,basepath,);

    url.searchParams.append("storeId", storeId.toString());
    if (universeCode) url.searchParams.append("universeCode", universeCode);
    if (gridCode) url.searchParams.append("gridCode", gridCode);
    if (lang) url.searchParams.append("lang", lang);
  
    try {
      const response = await fetch(url.toString(), options);
      return await response.text();
    } catch (error) {
      throw new Error("Network response was not ok");
    }
}